import type { Entity } from '@backstage/catalog-model';
import type { JiraAnnotations } from '../api/jql';

const ANNOTATION_PROJECT_KEY = 'jira/project-key';
const ANNOTATION_COMPONENT = 'jira/component';
const ANNOTATION_LABEL = 'jira/label';
const ANNOTATION_TEAM = 'jira/team';
const ANNOTATION_ALL_ISSUES_JQL = 'jira/all-issues-jql';

export function useJiraAnnotations(entity: Entity): JiraAnnotations {
  const ann = entity.metadata.annotations ?? {};
  return {
    projectKey: ann[ANNOTATION_PROJECT_KEY],
    component: ann[ANNOTATION_COMPONENT],
    label: ann[ANNOTATION_LABEL],
    team: ann[ANNOTATION_TEAM],
    allIssuesJql: ann[ANNOTATION_ALL_ISSUES_JQL],
  };
}

export function isJiraAvailable(entity: Entity): boolean {
  const ann = entity.metadata.annotations ?? {};
  return Boolean(ann[ANNOTATION_PROJECT_KEY] || ann[ANNOTATION_ALL_ISSUES_JQL]);
}
